'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiThumbsOk = function TiThumbsOk(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.5 21c-0.2-0.5-0.3-1-0.7-1.5 0.5-1 0.9-1.7 0.5-3.2-0.3-1.3-1.3-2.8-2.6-4.1l-2.9-1.5 1.4-3c0.6-1.4 0.6-3-0.2-4.2-0.8-1.3-2.3-2.2-3.8-2.2-1.7 0-3 1-3.9 2.5 0 0-1.3-0.3-3 0.2l-2.1 2s-2.9 0.8-3.4 3.3-0.6 5.7-1.3 6.9-4.2 5.5-6.2 7.8c-1.5 1.8-1.1 3.8 0.2 5.3l8.3 8.4c1.4 1.3 4.5 1.8 6.7-0.5 2.3-2.4 0.8-5.5 0.8-5.5 0.7-0.5 2.5-2 4.4-2.5s4.6-1.5 6.1-3.5c1.4-1.7 2-3 1.7-4.7z m-15.5 13.8c-0.7 0.7-1.7 0.7-2.3 0l-7-7c-0.4-0.3-0.5-0.6-0.5-1.1s0.1-0.9 0.5-1.2l1.1-1.2 8.2 8.2c0.3 0.3 0.5 0.7 0.5 1.2s-0.2 0.8-0.5 1.1z m11-16.5c-0.8 0-1.2-0.8-1.8-1.5s-2.2-0.8-3.4-0.3-1.6 1.7-1.6 2.8c0 1.7 1.1 3.2 2.8 3.2 1.2 0 1.5-0.2 2.2-0.5 1-0.7 1.3-1.3 2-1.3s1.1 0.3 1.1 1.3-1 2.2-2 2.8-1.8 0.9-2.8 1c-1 0.2-1.7 0.2-3 1-1.2 0.7-2.3 1.5-3 2.2l-7.7-7.7c1.5-1.8 2.9-3.8 3-4.8l1.2-6.5c0.2-0.7 0.7-0.8 1-0.8 0.5 0 1 0.3 1.2 0.6l0.6-2.1c0.2-0.5 0.7-0.9 1-0.9 0.7 0 1.4 0.5 1.2 1.4l-0.8 4c1-2 2.5-4.5 3.5-6.4 0.3-0.5 0.6-1 1.5-1s1.5 1 1.1 1.9c-0.3 0.6-3.3 5.8-4.6 8-0.2 0.1 0 0.3 0.3 0.1 0.5-0.3 1.7-1.1 2.8-1.1 2-0.2 3 0.6 3.5 1 0.7 0.5 1.4 1.3 1.9 2.1 0.3 0.9-0.4 1.5-1.2 1.5z m-0.3 1.2c-0.7 0-1.2 0.2-1.5 0.7s-1 1.1-1.9 1.1c-1.1 0-1.8-0.8-1.8-1.8s0.7-1.7 1.8-1.7c0.9 0 1.5 0.7 1.9 1.2s0.8 0.5 1.5 0.5z' })
        )
    );
};

exports.default = TiThumbsOk;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/thumbs-ok.js
// module id = 3767
// module chunks = 0